export enum UserRoleName {
  Admin = 'Admin',
  Doctor = 'Doctor',
  Frontdesk = 'Front Desk',
  Patient = 'Patient',
  Finance = 'Finance',
}
